import { AppConfig } from '../../app.config';

declare var NeWMI; // newmi-tbd

export interface IMapEventsHandler {
  onMapEvent(event): boolean; // Return true if event was consumed
}

class SelectionTool extends NeWMI.Tool.SelectionTool {

  constructor() {
    super();
    this.caption = "EURO_N Special Selection Tool";
    this.id = SelectionTool.ID;
  }

  start(params) {
    this.activate();
    this.onMapEvent(params);
  }

  performSelection(objSelectionGeo: NeWMI.Geometry.Base.AGeometry, selectionType: NeWMI.Selection.Enums.ESelectionType) {
    const res = super.performSelection(objSelectionGeo, selectionType);
    this.deactivate();
    return res;
  }

  static get ID() {
    return "Tool_EURO_N_Selection_Tool"
  }

}

export class SpecialTool extends NeWMI.Tool.Base.ATool {

  selTool: SelectionTool;

  constructor(mapEvents, private eventsHandler: IMapEventsHandler) {
    super(mapEvents);

    this.caption = "EURO_N Special Tool";
    this.id = SpecialTool.ID;

    this.selTool = new SelectionTool();
    this.selTool._creationTool._feedbackLayer.drawingStyles.anchorDraw = [function(){}];

  }

  init(objMap: NeWMI.Map.Base.ABasicMap) {
    super.init(objMap);
    this.selTool.init(objMap);
  }

  activate(oldTool?: NeWMI.Tool.Base.ATool): boolean {
    super.activate(oldTool);
    this.map.setNavigationMode({ pan: true, zoom: true });
    this.map.div.setAttribute("oncontextmenu", 'return false;');

    if (AppConfig.settings.map.esri) { // newmi-tbd
      // ???
    }
    else {
      this.map._interactions.pan.condition_ = function (e) {
        if (e.pointerEvent.buttons === 1) { // !!! this is where we change the map pan...
          return true;
        }
        return false;
      };
    }

    return true;
  }

  deactivate(newActivatedTool?: NeWMI.Tool.Base.ATool): boolean {
    super.deactivate(newActivatedTool);
    this.map.div.removeAttribute("oncontextmenu");
    return true;
  }

  
  onMapEvent(evt) {
    super.onMapEvent(evt);
    if (!this.eventsHandler.onMapEvent(evt)) {
      // if (evt.eventType == NeWMI.Map.Enums.EMapEvents.MouseDown) {
      //   if (evt.button == 2) { 
      //     // left mouse button
      //     this.selTool.start(event); // !!! selection tool activation
      //   }
      // }
    }
  }

  static get ID() {
    return "Tool_EURO_N_SpecialTool";
  }
}
